import { createSlice } from "@reduxjs/toolkit";

/* -------------------------------------------------------------------------- */
/* Initial State                                                              */
/* -------------------------------------------------------------------------- */

const currentDate = new Date().toISOString().slice(0, 10);

export const initialContractState = {
  title: "Contract 01",
  contractType: null,
  invoiceAddress: null,
  startDate: currentDate,
  endDate: null,
  notes: null,
  invoiceInterval: null,
  priceIncludesVat: false,
  insurancePercentage: null,
  invoiceDescription: null,
  useUnitsForInvoiceValue: false,
  listAssignedUnitsOnInvoice: false,
  rate: null,
  ratePeriod: null,
  rateDescription: null,
  status: "In storage",
  sites: [],
};

const initialState = {
  contractList: [],
  contractPagination: [],
  isCreateContractResponse: false,
  singleContractDetail: null,
  customerStorageResponse: null,
};
/* -------------------------------------------------------------------------- */
/* Contract Storage Slice                                                              */
/* -------------------------------------------------------------------------- */

export const contractStorageSlice = createSlice({
  name: "contractStorage",
  initialState,
  reducers: {
    getContractListAction: (state, { payload }) => {},
    setContractListAction: (state, { payload }) => {
      state.contractList = payload?.list;
      state.contractPagination = payload?.pagination;
    },

    createContractAction: (state, { payload }) => {},
    setCreateContractResponseAction: (state, { payload }) => {
      state.isCreateContractResponse = payload;
    },

    getSingleContractAction: (state, { payload }) => {},
    setSingleContractAction: (state, { payload }) => {
      state.singleContractDetail = payload;
    },

    updateContractAction: (state, { payload }) => {},

    /* ---------------------------------------------------------------------- */ /* Clear Single Contract Detail */ /* ---------------------------------------------------------------------- */
    clearSingleContractDetailAction: (state) => {
      state.singleContractDetail = null;
    },
    /* ---------------------------------------------------------------------- */ /* Reset Create Contract Response */ /* ---------------------------------------------------------------------- */
    resetCreateContractResponseAction: (state) => {
      state.isCreateContractResponse = false;
    },

    checkCustomerStorageAction: (state, { payload }) => {},
    setCheckCustomerStorageResponseAction: (state, { payload }) => {
      state.customerStorageResponse = payload;
    },

    clearCustomerStorageCheckResponse: (state) => {
      state.customerStorageResponse = null;
    },
  },
});

/* -------------------------------------------------------------------------- */
/* Reducer                                                                    */
/* -------------------------------------------------------------------------- */

const {
  getContractListAction,
  setContractListAction,
  createContractAction,
  updateContractAction,
  setCreateContractResponseAction,
  getSingleContractAction,
  setSingleContractAction,
  clearSingleContractDetailAction,
  resetCreateContractResponseAction,
  checkCustomerStorageAction,
  setCheckCustomerStorageResponseAction,
  clearCustomerStorageCheckResponse,
} = contractStorageSlice.actions;
export {
  getContractListAction,
  setContractListAction,
  createContractAction,
  updateContractAction,
  setCreateContractResponseAction,
  getSingleContractAction,
  setSingleContractAction,
  clearSingleContractDetailAction,
  resetCreateContractResponseAction,
  checkCustomerStorageAction,
  setCheckCustomerStorageResponseAction,
  clearCustomerStorageCheckResponse,
};
export default contractStorageSlice.reducer;
